import { useEffect } from "react";

const Redirect = () => {
  useEffect(() => {
    window.location.href = "https://awesome-equalizer.app";
  }, []);

  return null;
};

export default Redirect;